<template>
  <modal title="" width="35" :showModal="showModal" @close-modal="closeModal">
    <div class="table__search-input-wrapper w-[350px] filter-search">
      <span class="pr-2 opacity-50"><search-icon /> </span>

      <input type="text" class="table__search-input" placeholder="Search..." />
    </div>

    <div class="individual-contaoner">
      <label class="label">FILTER BY: <span class="text-sm text-primary-yellow">Shipping ID(s)</span></label>
      <el-select filterable v-model="shippingID" placeholder="All" @change="handleSelectChange('shippingID', $event)">
        <el-option v-for="trans in allTransactions" :key="trans.id" :label="trans.shipping.shippingReference"
          :value="trans.shipping.shippingReference">
        </el-option>
      </el-select>
    </div>

    <div class="individual-contaoner">
      <label class="label">FILTER BY: <span class="text-sm text-primary-yellow">Past Earning Cycles</span></label>
      <div class="cycle-container flex">
        <div>
          <el-select @change="handleSelectChange('cycle', $event)" class="no-border-select" filterable
            v-model="filteredMonth" placeholder="Month">
            <el-option v-for="(month, index) in dateFilterOptions[0].months" :key="index" :label="month.label" :value="month.value">
            </el-option>
          </el-select>
        </div>
        <div>
          <el-select @change="handleSelectChange('cycle', $event)" class="no-border-select" filterable
            v-model="filteredYear" placeholder="Year">
            <el-option v-for="(year, index) in years" :key="index" :label="year" :value="year"></el-option>
          </el-select>
        </div>
      </div>
    </div>

    <div class="actions flex items-center cursor-pointer mt-5">
      <div @click="apply">
        <primary-button buttonText="Apply" :loading="loading" :disabled="!canApply" />
      </div>
      <div>
        <p @click="closeModal()" class="pl-3">Cancel</p>
      </div>

    </div>
  </modal>
</template>

<script>
import moment from "moment";

export default {
  props: {
    showModal: {
      type: Boolean,
      required: true,
    },
    allTransactions: {
      required: true,
    },

  },

  data() {
    return {
      currentYear: moment().format("YYYY"),
      years: [],
      filteredMonth: '',
      filteredYear: '',
      selectedField: null,
      selectedValue: null,
      loading: false,
      shippingID: null,
      cycle: null,

      dateFilterOptions: [
        {
          months: [
            { label: 'Jan', value: '1' },
            { label: 'Feb', value: '2' },
            { label: 'Mar', value: '3' },
            { label: 'Apr', value: '4' },
            { label: 'May', value: '5' },
            { label: 'Jun', value: '6' },
            { label: 'Jul', value: '7' },
            { label: 'Aug', value: '8' },
            { label: 'Sep', value: '9' },
            { label: 'Oct', value: '10' },
            { label: 'Nov', value: '11' },
            { label: 'Dec', value: '12' },
          ],
        },
      ]
    };
  },
  mounted() {
    const startYear = 1990;
    const endYear = Number(this.currentYear);

    for (let y = endYear; y >= startYear; y--) {
      this.years.push(y);
    }
  },

  computed: {
    canApply() {
      if (this.selectedField === 'shippingID') {
        return this.shippingID;
      }

      if (this.selectedField === 'cycle') {
        return this.filteredMonth && this.filteredYear;
      }

      return false;
    }
  },


  methods: {


    closeModal() {
      this.$emit("close-modal");
    },

    handleSelectChange(field, value) {
      this.selectedField = field;
      this.selectedValue = value;
    },

    isDisabled(field) {
      // Disable all other select fields if one is selected
      return this.selectedField && this.selectedField !== field;
    },


    apply() {
      if (this.selectedField === 'shippingID') {

        this.$emit("appliedRef", this.shippingID);

      } else if (this.selectedField === 'cycle') {

        this.$emit("filteredCycle", this.filteredMonth, this.filteredYear);
      }

      this.closeModal();
      this.shippingID = null;
      this.filteredMonth = '';
      this.filteredYear = '';
    },

  },
};
</script>

<style scoped lang="scss">
.cycle-container {
  // border: 1px solid #B7BDCD;
  // border-radius: 8px;
}


.label {
  @apply border-b-2 border-gray-400 w-full pb-1;
  font-size: 13px;
}

.individual-contaoner {
  @apply w-full border-2 border-gray-300 border-dashed p-2 my-3
}

.filter-search {
  border-radius: 4px;
  @apply py-2
}
</style>
